/**
 * @fileoverview POST handler for the "/engagement/product_recommendations" endpoint
 */
import type { PredictionUpdatePayload } from "@predictions/PredictionDigest/types";
import type { PredictionPayload } from "@predictions/types";

import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementProductRecommendationsCacheKeys } from "./constants";

export const postEngagementProductRecommendations = reactQueryMutationAdapter(
  engagementProductRecommendationsCacheKeys,
  (props: PredictionUpdatePayload): Promise<PredictionPayload> => {
    return fetch("/engagement/product_recommendations", "POST", props);
  }
);
